import { TFunction } from '@lyearn/i18n';
import { Trash2Outline } from '@lyearn/icons';
import { CopyIcon } from '@lyearn/icons';
import { ActionMenuItemProps } from '@lyearn/molecules';

import { GroupConditionAction } from '../../types';

export const getMenuItems = (t: TFunction): ActionMenuItemProps[] => [
  {
    id: GroupConditionAction.Duplicate,
    label: t('Common:Actions.Duplicate'),
    EndIcon: CopyIcon,
  },
  {
    id: GroupConditionAction.Delete,
    label: t('Common:Actions.Delete'),
    EndIcon: Trash2Outline,
    appearance: 'danger',
  },
];
